import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { IGenerator } from '@web/entities/generator/model/types'
import type { IReport } from '@web/entities/report'
import {
  generationPdfHarmonic,
  generationPdfSquare,
  generationPdfVp3701
} from '@web/entities/report/model/reports.thunk'
import type { IVp3701ListItem } from '@web/entities/vp-3701'
import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'
import {
  errorNotificationCreate,
  successNotificationCreate
} from '@web/shared/utils/notification-creators.util'

export interface IReportsSlice {
  selectedReport: IReport | null
  checkedData: IVp3701ListItem[] | IGenerator[]
}

const initialState: IReportsSlice = {
  selectedReport: null,
  checkedData: []
}

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setSelectedReport(state, action: PayloadAction<IReport>) {
      state.selectedReport = action.payload
    },
    setCheckedData(
      state,
      action: PayloadAction<IGenerator[] | IVp3701ListItem[]>
    ) {
      state.checkedData = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(generationPdfVp3701.fulfilled, () => {
      successNotificationCreate('PDF-файл успешно создан')
    })
    builder.addCase(generationPdfVp3701.rejected, () => {
      errorNotificationCreate('Ошибка при создании PDF-файла')
    })
    builder.addCase(generationPdfHarmonic.fulfilled, () => {
      successNotificationCreate('PDF-файл успешно создан')
    })
    builder.addCase(generationPdfHarmonic.rejected, () => {
      errorNotificationCreate('Ошибка при создании PDF-файла')
    })
    builder.addCase(generationPdfSquare.fulfilled, () => {
      successNotificationCreate('PDF-файл успешно создан')
    })
    builder.addCase(generationPdfSquare.rejected, () => {
      errorNotificationCreate('Ошибка при создании PDF-файла')
    })
  }
})

export const reportsReducer = reportsSlice.reducer
export const useReportsActions = () =>
  useDispatchedActions(reportsSlice.actions)
